var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
var IncomingCallComponent = /** @class */ (function () {
    function IncomingCallComponent(apiService, util, activatedRoute, router) {
        this.apiService = apiService;
        this.util = util;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.isCrisis = true;
    }
    IncomingCallComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para, contact, name_1, firstname, lastname, phoneNo, i, req, phone, firstname, lastname, phoneNo, req;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.isCrisis = this.cookieData.isCrisis;
                        this.activatedRoute.queryParams.subscribe(function (params) {
                            _this.telephoneNo = params['phoneNo'];
                            _this.idCard = params['idCard'];
                        });
                        if ((this.telephoneNo == null || this.telephoneNo.toString().trim().length == 0) &&
                            (this.idCard == null || this.idCard.toString().trim().length == 0)) {
                            this.util.ErrorDialog("กรุณาระบุข้อมูล phoneNo หรือ idCard");
                            return [2 /*return*/];
                        }
                        para = "";
                        if (this.telephoneNo != null && this.telephoneNo.trim().length > 0) {
                            para += para.length > 0 ? "&telephoneno=" + this.telephoneNo : "telephoneno=" + this.telephoneNo;
                        }
                        if (this.idCard != null && this.idCard.trim().length > 0) {
                            para += para.length > 0 ? "&idcard=" + this.idCard : "idcard=" + this.idCard;
                        }
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        contact = _a.sent();
                        this.util.ShowWaiting(false);
                        if (!(contact == null || contact.length == 0)) return [3 /*break*/, 11];
                        if (!this.isCrisis) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.getDrosContact()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getDAContact()];
                    case 3:
                        _a.sent();
                        if (!(this.contactDros != null && this.contactDros.CRM06 != null && this.contactDros.CRM06.Name != null)) return [3 /*break*/, 5];
                        name_1 = this.contactDros.CRM06.Name.split(" ");
                        firstname = "";
                        lastname = "";
                        phoneNo = "";
                        if (name_1.length > 0) {
                            if (name_1.length == 1) {
                                firstname = name_1[0];
                            }
                            else if (name_1.length == 2) {
                                firstname = name_1[0];
                                lastname = name_1[1];
                            }
                            else if (name_1.length > 2) {
                                for (i = 0; i < name_1.length - 1; i++) {
                                    firstname += " " + name_1[i];
                                }
                                firstname = firstname.trim();
                                lastname = name_1[name_1.length - 1];
                            }
                        }
                        if (this.telephoneNo != null && this.telephoneNo.trim().length > 0) {
                            phoneNo = this.telephoneNo;
                        }
                        else {
                            phoneNo = this.contactDros.CRM06.PhoneNo;
                        }
                        req = {
                            createdon: new Date().toISOString(),
                            modifiedon: new Date().toISOString(),
                            firstname: firstname,
                            lastname: lastname,
                            dpa_idcard: this.contactDros.CRM06.IDNo,
                            dpa_authorizedperson_idcard: this.contactDros.CRM06.IDNo,
                            dpa_authorizedperson_telephone: phoneNo,
                            telephone1: phoneNo,
                            emailaddress1: this.contactDros.CRM06.Email,
                            statusreason: 1,
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", req).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "") {
                                            //new tab customer4tab (2)
                                            this.router.navigate(["/customer/" + res.contactid]);
                                        }
                                        else {
                                            this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ");
                                        }
                                    }
                                    else {
                                        this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ");
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        if (!(this.contactDa != null && this.contactDa.FirstName.trim().length > 0)) return [3 /*break*/, 7];
                        phone = this.contactDa.MobileNumber.split(",");
                        firstname = this.contactDa.FirstName;
                        lastname = this.contactDa.LastName;
                        phoneNo = "";
                        if (this.telephoneNo != null && this.telephoneNo.trim().length > 0) {
                            phoneNo = this.telephoneNo;
                        }
                        else {
                            if (phone.length > 0 && phone[0] != "N/A") {
                                phoneNo = phone[0];
                            }
                            else {
                                phoneNo = this.telephoneNo;
                            }
                        }
                        req = {
                            createdon: new Date().toISOString(),
                            modifiedon: new Date().toISOString(),
                            firstname: firstname,
                            lastname: lastname,
                            dpa_idcard: this.contactDa.IdentityNumber,
                            dpa_authorizedperson_idcard: this.contactDa.IdentityNumber,
                            dpa_authorizedperson_telephone: phoneNo,
                            telephone1: phoneNo,
                            emailaddress1: this.contactDa.EmailAddress,
                            statusreason: 1,
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contact", req).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.util.isSuccessResponse(res)) {
                                        if (res.contactid != null && res.contactid != "") {
                                            //new tab customer4tab (2)
                                            this.router.navigate(["/customer/" + res.contactid]);
                                        }
                                        else {
                                            this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ");
                                        }
                                    }
                                    else {
                                        this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ");
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        // this.cookieData.incomingTelephoneNo = this.telephoneNo
                        // this.cookieData.incomingIdCard = this.idCard
                        // localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))
                        //หน้าจอค้นหา Contact(1)
                        if (this.idCard != null && this.idCard.trim().length > 0) {
                            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo, idCard: this.idCard } });
                        }
                        else {
                            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo } });
                        }
                        _a.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        this.cookieData.incomingTelephoneNo = this.telephoneNo;
                        this.cookieData.incomingIdCard = this.idCard;
                        localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
                        this.router.navigate(["/newContact"]);
                        _a.label = 10;
                    case 10: return [3 /*break*/, 16];
                    case 11:
                        if (!(contact.length == 1)) return [3 /*break*/, 15];
                        if (!this.isCrisis) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.getDrosContact()];
                    case 12:
                        _a.sent();
                        if (this.contactDros != null || this.contactDros.CRM06 != null) {
                            //หน้าจอค้นหา Contact(1)
                            if (this.idCard != null && this.idCard.trim().length > 0) {
                                this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo, idCard: this.idCard } });
                            }
                            else {
                                this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo } });
                            }
                        }
                        else {
                            //Customer4Tab (2)
                            this.router.navigate(["/customer/" + contact[0].contactid]);
                        }
                        return [3 /*break*/, 14];
                    case 13:
                        this.router.navigate(["/customer/" + contact[0].contactid]);
                        _a.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        if (this.idCard != null && this.idCard.trim().length > 0) {
                            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo, idCard: this.idCard } });
                        }
                        else {
                            this.router.navigate(['/incomingContact'], { queryParams: { phoneNo: this.telephoneNo } });
                        }
                        _a.label = 16;
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    IncomingCallComponent.prototype.getDrosContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "CRM06=true";
                        if (this.idCard != null && this.idCard.toString().trim().length > 0) {
                            para += "&dpa_id=" + this.idCard;
                        }
                        if (this.telephoneNo != null && this.telephoneNo.toString().trim().length > 0) {
                            para += "&telephoneno=" + this.telephoneNo;
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)]; //ค้น DROS
                    case 1:
                        _a.contactDros = _b.sent(); //ค้น DROS
                        return [2 /*return*/];
                }
            });
        });
    };
    IncomingCallComponent.prototype.getDAContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "";
                        if (this.idCard != null && this.idCard.toString().trim().length > 0) {
                            para += "IdNo=" + this.idCard;
                        }
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getDA", para)]; //ค้น DA
                    case 1:
                        _a.contactDa = _b.sent(); //ค้น DA
                        return [2 /*return*/];
                }
            });
        });
    };
    return IncomingCallComponent;
}());
export { IncomingCallComponent };



// WEBPACK FOOTER //
// ./src/app/incoming-call/incoming-call.component.ts.pre-build-optimizer.js